import { useState, useEffect } from 'react';
import { SportProvider } from '../../models/interfaces/SportProvider';
import { Container, Row, Button, Col, Spinner } from 'react-bootstrap';
import { SponsorBanner } from './SponsorBanner';
import { FeaturedEventsView } from '../events/FeaturedEventsView';
import { useHistory } from 'react-router-dom';
import { User } from '../../models/interfaces/User';
import { subscribeHomeLoads } from '../../helpers/homeLoadTiming';
import { useSponsors } from '../../helpers/useSponsors';

interface Props {
  sportProvider: SportProvider;
  user?: User;
}

export default function WPAusLandingPage({ sportProvider, user }: Props) {
  const history = useHistory();
  useEffect(() => subscribeHomeLoads(timing => sportProvider.analytics?.logHomeLoad?.(timing)), [sportProvider]);
  const [firstEventId, setFirstEventId] = useState<string | undefined>(undefined);
  
  // Fetch sponsors using the first event's ID
  const { sponsors, loading: sponsorsLoading, error: sponsorsError } = useSponsors(firstEventId);

  return (
    <Container className="py-3">
      <Row className="mb-3">
        <Col>
          <h1 style={{ marginTop: '4px', marginBottom: '8px', color: 'var(--wpa-dark-blue)' }}>Live Scores &amp; Results</h1>
        </Col>
      </Row>
      <FeaturedEventsView sportProvider={sportProvider} user={user} onFirstEventId={setFirstEventId} />
      <Row className='justify-content-center py-4'>
        <Button
          style={{ backgroundColor: 'var(--wpa-yellow)', color: 'var(--wpa-dark-blue)', borderColor: 'var(--wpa-yellow)', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', fontFamily: 'var(--wpa-font-heading)' }}
          onClick={() => { history.push('/all_wpa') }}
        >
          More Tournaments
        </Button>
      </Row>
      <Row style={{ minHeight: 190 }}>
        {(() => {
          if (sponsorsLoading) {
            return (
              <Col className="sponsorBanner">
                <div style={{
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  padding: '20px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '4px',
                  border: '1px solid #dee2e6',
                  position: 'relative'
                }}>
                  <div style={{
                    position: 'absolute',
                    width: '4rem',
                    height: '4rem',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    zIndex: 0
                  }}></div>
                  <Spinner 
                    animation="border" 
                    role="status" 
                    variant="primary"
                    style={{ 
                      width: '3rem', 
                      height: '3rem',
                      position: 'relative',
                      zIndex: 1
                    }}
                  >
                    <span className="sr-only">Loading sponsors...</span>
                  </Spinner>
                </div>
              </Col>
            );
          }
          
          if (sponsorsError) {
            return null;
          }
          
          if (sponsors && sponsors.length > 0) {
            return <SponsorBanner sponsors={sponsors} />;
          }
          
          return null;
        })()}
      </Row>
    </Container>
  );
}
